@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/left-nav.module.less';

@contractedAddToBatchMenuHeight: 42px;
@searchAreaHeightWithBorder: 71px;

.tree-nav-container {
  height: 100%;
}

.tree-and-batches {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: calc(100% - (@contractedAddToBatchMenuHeight + @searchAreaHeightWithBorder));
  overflow: hidden auto;
  > * {
    position: relative;

    &:first-child {
      z-index: 1;
    }

    &:last-child {
      z-index: 2;
      position: absolute;
    }
  }
}

.search-area {
  overflow-y: auto;
  height: 100%;
}

.search-area-highlighted {
  background: var(--left-nav--advanced-search-active-color);
}

.search-area-buttons {
  border-bottom: 1px solid @left-nav--search-area--border-bottom-color;
}
